module.exports = __webpack_public_path__ + "img/PT3.7fccf194.png";